<template>
  <main class="catalog container">
    <ul class="nav nav-fill" id="catalogTab" role="tablist">
      <li class="nav-item">
        <a
          class="nav-link"
          id="ize-tab"
          role="tab"
          :class="{active: activeTab == 'coins'}"
          @click="activeTab = 'coins'"
        >{{$t('One shot rewards')}}</a>
      </li>
    </ul>
    <div class="tab-content" id="catalogTabContent" v-if="catalog">
      <div
        class="tab-pane fade show active"
        id="ize"
        role="tabpanel"
        aria-labelledby="ize-tab"
        v-if="activeTab == 'coins'"
      >
        <div class="row">
          <div class="col-12 col-md-4" v-for="(reward,index) in catalog.coins" :key="index">
            <div
              class="card mouse-pointer"
              @click="goToReward(reward)"
              style="height: calc(100% - 20px);"
            >
              <div class="card-body d-flex flex-column justify-content-start">
                <div class="img-container">
                  <img :src="reward.image" :alt="reward.title" class="img-fluid" />
                </div>
                <h5 class="card-title text-primary text-uppercase text-left text-md-center" v-cloak>
                  {{reward.cost}} {{$t('points')}}
                  <br />
                  <small calss="text-muted" style="font-size:60%;color:#989898">
                    <span v-if="reward.max_requests-reward.redeems>1">
                      {{$t('Richiedibile')}}
                      <strong>@{{reward.max_requests-reward.redeems}} {{$t('volte')}}</strong>
                    </span>
                    <span v-else>&nbsp;</span>
                  </small>
                </h5>
                <h4 class="card-title text-left text-md-center">{{reward.title}}</h4>
                <div>{{ (reward.description.length > 200) ? reward.description.substring(0,200) + '...' : reward.description }}</div>
                <div class="text-center redeem">
                  <template v-if="reward.redeemable">
                    <button
                      @click="goToReward(reward)"
                      class="btn btn-primary text-uppercase"
                    >{{$t('Mostra Dettagli')}}</button>
                  </template>
                  <template v-else>
                    <div
                      class="btn btn-grey text-uppercase"
                      style="display: inline-block;cursor:initial;background-color: #21252908;"
                    >{{$t('Già richiesto')}}</div>
                  </template>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        class="tab-pane fade show active"
        id="points"
        role="tabpanel"
        aria-labelledby="points-tab"
        v-if="activeTab == 'points'"
      >
        <div class="row">
          <div class="col-12 col-md-4" v-for="(reward,index) in catalog.points" :key="index">
            <div
              class="card mouse-pointer"
              @click="goToReward(reward)"
              style="height: calc(100% - 20px);"
            >
              <div class="card-body d-flex flex-column justify-content-start">
                <div class="img-container">
                  <img :src="reward.image" :alt="reward.title" class="img-fluid" />
                </div>
                <h5 class="card-title text-primary text-uppercase text-left text-md-center" v-cloak>
                  {{$t('Level')}} {{reward.at_level}}
                  <br />
                  <small calss="text-muted" style="font-size:60%;color:#989898">
                    <span v-if="reward.max_requests-reward.redeems>1">
                      {{$t('Richiedibile')}}
                      <strong>{{reward.max_requests-reward.redeems}} {{$t('volte')}}</strong>
                    </span>
                    <span v-else>&nbsp;</span>
                  </small>
                </h5>
                <h4 class="card-title text-left text-md-center">{{reward.title}}</h4>
                <div class="text-center redeem">
                  <template v-if="reward.redeemable">
                    <button
                      @click="goToReward(reward)"
                      class="btn btn-primary text-uppercase"
                    >{{$t('Mostra Dettagli')}}</button>
                  </template>
                  <template v-else>
                    <div
                      class="btn btn-grey text-uppercase"
                      style="display: inline-block;cursor:initial;background-color: #21252908;"
                    >{{$t('Già sbloccato')}}</div>
                  </template>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </main>
</template>
<script>
import _ from "lodash";
export default {
  name: "catalog",
  data() {
    return {
      catalog: null,
      activeTab: "coins"
    };
  },
  created() {
    this.getCatalog();
  },
  methods: {
    async getCatalog() {
      this.$store.commit("showSpinner");
      try {
        let response = await this.$http.get(
          "api/v1/campaigns/" +
            this.$store.state.campaign.id +
            "/catalog/rewards"
        );

        this.catalog = _.get(response, "data.data", null);
      } catch (e) {
        this.$store.commit("pushMessage", {
          type: "error",
          title: "Error",
          text: "An error occurred"
        });
      }

      this.$store.commit("hideSpinner");
    },
    goToReward(reward) {
      this.$router.push({
        name: "reward",
        params: { rewardProp: reward },
        query: { rewardId: reward.id }
      });
    }
  }
};
</script>
<style>
main #catalogTabContent .card {
  background-color: #fff;
  min-height: 422px;
  margin-bottom: 20px;
}
main #catalogTabContent .card .img-container {
  width: 100%;
  height: 210px;
  border-radius: 5px;
  box-shadow: 10px 10px 20px 0 rgba(2, 8, 22, 0.1);
  background-color: #e2e6e7;
  border: solid 1px #f1f1f1;
  overflow: hidden;
  position: relative;
  text-align: center;
  line-height: 206px;
  margin-bottom: 20px;
}
main #catalogTabContent .card .img-container img {
  max-height: 100%;
  max-width: 100%;
}
main #catalogTabContent .card .no-redeem,
main #catalogTabContent .card .redeem {
  min-height: 58px;
}
main #catalogTabContent .card .redeem {
  line-height: 58px;
}
main #catalogTabContent .card .no-redeem {
  background-color: rgba(249, 193, 222, 0.2);
  padding: 5px;
  border-radius: 0.25rem;
}
</style>
